import { FC, useContext, useEffect } from "react";
// import Emptymiddleware from '../middlewares/Emptymiddleware'
import TokenMiddlewareTable from "./Tokenmiddleware";

import { TableInputProps } from "../Table";

import store from "../../../store/store";
import { removeBreadcrumb } from "../../../components/Breadcrumbs/reducer/breadcrumbSlice";
import { GENERAL } from "../config/Transaction/ProductGeneralConf";
import { useSelector } from "react-redux";
import { fetchAllUsers } from "../reducer/userSlice";

const InitMiddlewareTable: FC<TableInputProps> = (props) => {
  const { categoryData } = useSelector(
    (state: any) => state.rootReducer.brand
  );
  const { entityData, done } = useSelector((state: any) => state.DeletePopup);
  

  console.log('user done', done)

  useEffect(() => {
    store.dispatch(fetchAllUsers());
  }, []);

  // useEffect(() => {
  //   store.dispatch(removeBreadcrumb());
  // }, []);

  useEffect(() => {
    if (done) {
      store.dispatch(fetchAllUsers());
    }
  }, [done]);

  return <TokenMiddlewareTable {...props} />;
};

export default InitMiddlewareTable;
